export const PENDING='0'
export const VALID_PER_BIZ_RULES='1'
export const VALID_PER_SAMS='2'
export const INVALID_PER_BIZ_RULES='-1'
export const INVALID_PER_SAMS='-2'
export const SKIPPED_BY_USER='5'